"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BloodSacrificeAbilityHandler = exports.BloodSacrificeActorAbilityFactory = exports.BloodSacrificeAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Registries_1 = require("../../core/state/Registries");
const Target_1 = require("../../core/Target");
const Random_1 = require("../../utils/Random");
const AbilityDamage_1 = require("../../core/AbilityDamage");
const core_1 = require("../../core/vfx/core");
const LocationSelector_1 = require("../../core/vfx/LocationSelector");
class BloodSacrificeAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.BloodSacrifice;
        this.__typeName = "BloodSacrifice";
    }
}
exports.BloodSacrificeAbilityArgs = BloodSacrificeAbilityArgs;
let BloodSacrificeActorAbilityFactory = class BloodSacrificeActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("BloodSacrifice", "AllEnemies", 3);
    }
};
BloodSacrificeActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("BloodSacrifice")
], BloodSacrificeActorAbilityFactory);
exports.BloodSacrificeActorAbilityFactory = BloodSacrificeActorAbilityFactory;
let BloodSacrificeAbilityHandler = class BloodSacrificeAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        const enemies = container.selectLivingTargets(ability.invokerId, Target_1.Target.AllEnemies);
        container.applyMultiAttack({
            sequence,
            abilityKey: ability.args.__typeName,
            attackType: "magic",
            onDamage: (sequence, { targetId }) => sequence.push(new core_1.InstantVfxStepArgs(new LocationSelector_1.ActorVfxLocationSelector(targetId, "chest"), "BloodyClaws")),
            attackerId: ability.invokerId,
            targets: [
                ...enemies
                    .map(targetId => ({
                    targetId,
                    jitter: (0, Random_1.random)(25, 75),
                    damages: [
                        AbilityDamage_1.AbilityDamage.Focus("Death", 110)
                    ],
                }))
            ]
        });
    }
};
BloodSacrificeAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.BloodSacrifice)
], BloodSacrificeAbilityHandler);
exports.BloodSacrificeAbilityHandler = BloodSacrificeAbilityHandler;
